module.exports = new __parcel__URL__("integrations-task-two-illustration.1ec667da.svg").toString();